import React, { useState } from "react";
import Sidebar from "../components/Sidebar";

const Settings: React.FC = () => {
  const [activeTab, setActiveTab] = useState("general");
  const [settings, setSettings] = useState({
    general: {
      siteName: "Comex",
      siteUrl: "https://comex.com",
      timezone: "Asia/Bangkok",
      language: "th",
      currency: "THB",
    },
    payment: {
      promptpayId: "0840871065",
      promptpayName: "Comex Store",
      enablePromptPay: true,
      enableCreditCard: false,
      enableBankTransfer: false,
    },
    notifications: {
      emailNotifications: true,
      smsNotifications: false,
      pushNotifications: true,
      orderConfirmation: true,
      paymentAlerts: true,
      lowStockAlerts: true,
    },
    security: {
      twoFactorAuth: false,
      sessionTimeout: 30,
      passwordMinLength: 8,
      requireStrongPassword: true,
      ipWhitelist: "",
    },
    api: {
      enableApi: true,
      rateLimit: 1000,
      apiKey: "",
      webhookUrl: "",
    },
  });

  const handleSave = () => {
    alert("บันทึกการตั้งค่าสำเร็จ");
  };

  const tabs = [
    { id: "general", label: "ทั่วไป" },
    { id: "payment", label: "การชำระเงิน" },
    { id: "notifications", label: "การแจ้งเตือน" },
    { id: "security", label: "ความปลอดภัย" },
    { id: "api", label: "API" },
  ];

  return (
    <div className="flex min-h-screen bg-gray-100">
      <Sidebar />
      <div className="flex-1 p-8">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-3xl font-bold text-gray-900 mb-2">ตั้งค่า</h1>
          <p className="text-gray-600 mb-6">จัดการการตั้งค่าระบบและการกำหนดค่า</p>

          {/* Tabs */}
          <div className="bg-white rounded-lg shadow mb-6">
            <div className="border-b border-gray-200">
              <nav className="flex -mb-px">
                {tabs.map((tab) => (
                  <button
                    key={tab.id}
                    onClick={() => setActiveTab(tab.id)}
                    className={`px-6 py-4 text-sm font-medium border-b-2 ${
                      activeTab === tab.id
                        ? "border-blue-500 text-blue-600"
                        : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
                    }`}
                  >
                    {tab.label}
                  </button>
                ))}
              </nav>
            </div>

            {/* Tab Content */}
            <div className="p-6">
              {activeTab === "general" && (
                <div className="space-y-6">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      ชื่อระบบ
                    </label>
                    <input
                      type="text"
                      value={settings.general.siteName}
                      onChange={(e) =>
                        setSettings({
                          ...settings,
                          general: { ...settings.general, siteName: e.target.value },
                        })
                      }
                      className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      URL ระบบ
                    </label>
                    <input
                      type="url"
                      value={settings.general.siteUrl}
                      onChange={(e) =>
                        setSettings({
                          ...settings,
                          general: { ...settings.general, siteUrl: e.target.value },
                        })
                      }
                      className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      เขตเวลา
                    </label>
                    <select
                      value={settings.general.timezone}
                      onChange={(e) =>
                        setSettings({
                          ...settings,
                          general: { ...settings.general, timezone: e.target.value },
                        })
                      }
                      className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    >
                      <option value="Asia/Bangkok">Asia/Bangkok (GMT+7)</option>
                      <option value="Asia/Ho_Chi_Minh">Asia/Ho_Chi_Minh (GMT+7)</option>
                      <option value="Asia/Singapore">Asia/Singapore (GMT+8)</option>
                      <option value="UTC">UTC (GMT+0)</option>
                    </select>
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      ภาษา
                    </label>
                    <select
                      value={settings.general.language}
                      onChange={(e) =>
                        setSettings({
                          ...settings,
                          general: { ...settings.general, language: e.target.value },
                        })
                      }
                      className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    >
                      <option value="th">ไทย</option>
                      <option value="en">English</option>
                    </select>
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      สกุลเงิน
                    </label>
                    <select
                      value={settings.general.currency}
                      onChange={(e) =>
                        setSettings({
                          ...settings,
                          general: { ...settings.general, currency: e.target.value },
                        })
                      }
                      className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    >
                      <option value="THB">THB - บาทไทย</option>
                      <option value="USD">USD - US Dollar</option>
                      <option value="EUR">EUR - Euro</option>
                    </select>
                  </div>
                </div>
              )}

              {activeTab === "payment" && (
                <div className="space-y-6">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      PromptPay ID
                    </label>
                    <input
                      type="text"
                      value={settings.payment.promptpayId}
                      onChange={(e) =>
                        setSettings({
                          ...settings,
                          payment: { ...settings.payment, promptpayId: e.target.value },
                        })
                      }
                      className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                      placeholder="0840871065"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      ชื่อร้านค้า PromptPay
                    </label>
                    <input
                      type="text"
                      value={settings.payment.promptpayName}
                      onChange={(e) =>
                        setSettings({
                          ...settings,
                          payment: { ...settings.payment, promptpayName: e.target.value },
                        })
                      }
                      className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    />
                  </div>
                  <div className="space-y-3">
                    <label className="flex items-center">
                      <input
                        type="checkbox"
                        checked={settings.payment.enablePromptPay}
                        onChange={(e) =>
                          setSettings({
                            ...settings,
                            payment: { ...settings.payment, enablePromptPay: e.target.checked },
                          })
                        }
                        className="mr-2"
                      />
                      <span className="text-sm text-gray-700">เปิดใช้งาน PromptPay</span>
                    </label>
                    <label className="flex items-center">
                      <input
                        type="checkbox"
                        checked={settings.payment.enableCreditCard}
                        onChange={(e) =>
                          setSettings({
                            ...settings,
                            payment: { ...settings.payment, enableCreditCard: e.target.checked },
                          })
                        }
                        className="mr-2"
                      />
                      <span className="text-sm text-gray-700">เปิดใช้งานบัตรเครดิต</span>
                    </label>
                    <label className="flex items-center">
                      <input
                        type="checkbox"
                        checked={settings.payment.enableBankTransfer}
                        onChange={(e) =>
                          setSettings({
                            ...settings,
                            payment: { ...settings.payment, enableBankTransfer: e.target.checked },
                          })
                        }
                        className="mr-2"
                      />
                      <span className="text-sm text-gray-700">เปิดใช้งานโอนเงินธนาคาร</span>
                    </label>
                  </div>
                </div>
              )}

              {activeTab === "notifications" && (
                <div className="space-y-4">
                  <label className="flex items-center">
                    <input
                      type="checkbox"
                      checked={settings.notifications.emailNotifications}
                      onChange={(e) =>
                        setSettings({
                          ...settings,
                          notifications: { ...settings.notifications, emailNotifications: e.target.checked },
                        })
                      }
                      className="mr-2"
                    />
                    <span className="text-sm text-gray-700">การแจ้งเตือนทางอีเมล</span>
                  </label>
                  <label className="flex items-center">
                    <input
                      type="checkbox"
                      checked={settings.notifications.smsNotifications}
                      onChange={(e) =>
                        setSettings({
                          ...settings,
                          notifications: { ...settings.notifications, smsNotifications: e.target.checked },
                        })
                      }
                      className="mr-2"
                    />
                    <span className="text-sm text-gray-700">การแจ้งเตือนทาง SMS</span>
                  </label>
                  <label className="flex items-center">
                    <input
                      type="checkbox"
                      checked={settings.notifications.pushNotifications}
                      onChange={(e) =>
                        setSettings({
                          ...settings,
                          notifications: { ...settings.notifications, pushNotifications: e.target.checked },
                        })
                      }
                      className="mr-2"
                    />
                    <span className="text-sm text-gray-700">การแจ้งเตือนแบบ Push</span>
                  </label>
                  <label className="flex items-center">
                    <input
                      type="checkbox"
                      checked={settings.notifications.orderConfirmation}
                      onChange={(e) =>
                        setSettings({
                          ...settings,
                          notifications: { ...settings.notifications, orderConfirmation: e.target.checked },
                        })
                      }
                      className="mr-2"
                    />
                    <span className="text-sm text-gray-700">ยืนยันคำสั่งซื้อ</span>
                  </label>
                  <label className="flex items-center">
                    <input
                      type="checkbox"
                      checked={settings.notifications.paymentAlerts}
                      onChange={(e) =>
                        setSettings({
                          ...settings,
                          notifications: { ...settings.notifications, paymentAlerts: e.target.checked },
                        })
                      }
                      className="mr-2"
                    />
                    <span className="text-sm text-gray-700">แจ้งเตือนการชำระเงิน</span>
                  </label>
                  <label className="flex items-center">
                    <input
                      type="checkbox"
                      checked={settings.notifications.lowStockAlerts}
                      onChange={(e) =>
                        setSettings({
                          ...settings,
                          notifications: { ...settings.notifications, lowStockAlerts: e.target.checked },
                        })
                      }
                      className="mr-2"
                    />
                    <span className="text-sm text-gray-700">แจ้งเตือนสต็อกน้อย</span>
                  </label>
                </div>
              )}

              {activeTab === "security" && (
                <div className="space-y-6">
                  <label className="flex items-center">
                    <input
                      type="checkbox"
                      checked={settings.security.twoFactorAuth}
                      onChange={(e) =>
                        setSettings({
                          ...settings,
                          security: { ...settings.security, twoFactorAuth: e.target.checked },
                        })
                      }
                      className="mr-2"
                    />
                    <span className="text-sm text-gray-700">ยืนยันตัวตน 2 ขั้นตอน (2FA)</span>
                  </label>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      ระยะเวลาหมดอายุเซสชัน (นาที)
                    </label>
                    <input
                      type="number"
                      value={settings.security.sessionTimeout}
                      onChange={(e) =>
                        setSettings({
                          ...settings,
                          security: { ...settings.security, sessionTimeout: parseInt(e.target.value) },
                        })
                      }
                      className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      ความยาวรหัสขั้นต่ำ
                    </label>
                    <input
                      type="number"
                      value={settings.security.passwordMinLength}
                      onChange={(e) =>
                        setSettings({
                          ...settings,
                          security: { ...settings.security, passwordMinLength: parseInt(e.target.value) },
                        })
                      }
                      className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    />
                  </div>
                  <label className="flex items-center">
                    <input
                      type="checkbox"
                      checked={settings.security.requireStrongPassword}
                      onChange={(e) =>
                        setSettings({
                          ...settings,
                          security: { ...settings.security, requireStrongPassword: e.target.checked },
                        })
                      }
                      className="mr-2"
                    />
                    <span className="text-sm text-gray-700">ต้องการรหัสที่แข็งแรง</span>
                  </label>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      IP Whitelist (คั่นด้วยคอมมา)
                    </label>
                    <textarea
                      value={settings.security.ipWhitelist}
                      onChange={(e) =>
                        setSettings({
                          ...settings,
                          security: { ...settings.security, ipWhitelist: e.target.value },
                        })
                      }
                      className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                      rows={3}
                      placeholder="192.168.1.1, 10.0.0.1"
                    />
                  </div>
                </div>
              )}

              {activeTab === "api" && (
                <div className="space-y-6">
                  <label className="flex items-center">
                    <input
                      type="checkbox"
                      checked={settings.api.enableApi}
                      onChange={(e) =>
                        setSettings({
                          ...settings,
                          api: { ...settings.api, enableApi: e.target.checked },
                        })
                      }
                      className="mr-2"
                    />
                    <span className="text-sm text-gray-700">เปิดใช้งาน API</span>
                  </label>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      ขีดจำกัด Rate Limit (ต่อชั่วโมง)
                    </label>
                    <input
                      type="number"
                      value={settings.api.rateLimit}
                      onChange={(e) =>
                        setSettings({
                          ...settings,
                          api: { ...settings.api, rateLimit: parseInt(e.target.value) },
                        })
                      }
                      className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      API Key
                    </label>
                    <input
                      type="password"
                      value={settings.api.apiKey}
                      onChange={(e) =>
                        setSettings({
                          ...settings,
                          api: { ...settings.api, apiKey: e.target.value },
                        })
                      }
                      className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Webhook URL
                    </label>
                    <input
                      type="url"
                      value={settings.api.webhookUrl}
                      onChange={(e) =>
                        setSettings({
                          ...settings,
                          api: { ...settings.api, webhookUrl: e.target.value },
                        })
                      }
                      className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    />
                  </div>
                </div>
              )}
            </div>
          </div>

          {/* Save Button */}
          <div className="flex justify-end">
            <button
              onClick={handleSave}
              className="bg-blue-600 text-white px-6 py-2 rounded-lg hover:bg-blue-700 transition-colors"
            >
              บันทึกการตั้งค่า
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Settings;
